import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Logo from '../assets/MALogo.svg'
import Form1 from '../components/register/Form1'
import RegistrationConfirmation from '../components/register/RegistrationConfirmation'
import ToastNotification from '../components/ToastNotification'
import { checkSession } from '../auth/authService'

const Register = () => {
    
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [registerConfirmation, setRegisterConfirmation] = useState(false);
    const [serverMessage, setServerMessage] = useState(''); // State to hold error message
    // const testing = false;
    // const [emailConfirmation, setEmailConfirmation] = useState('example@myemail.com');

    const navigate = useNavigate();

    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    const signUp = async () => {

        if (!username || !email || !password) {
            setServerMessage({ success: false, message: 'All fields are required.' });
            return;
        }

        // STOP HERE AND IGNORE BELOW THIS LINE WHILE TESTING FORM VALIDATION WITH SIMPLE RETURN
        // if (testing) {
        //     setRegisterConfirmation(true);
        //     return { success: true, message: 'Testing mode: Registration simulated.' };
        // }

        try {
            const response = await fetch(`${apiUrl}/auth/create-user`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                username: username, 
                email: email, 
                password: password
                }),
            });

            const data = await response.json();

            // Means user exists but not confirmed signUp yet 
            if (response.status === 409) {
                const registrationVerification = await verifyUnconfirmedUser();
                return registrationVerification;
            }

            return data;
        
        } catch (error) {
            console.error('Error during sign up:', error);
            return { success: false, message: 'An error occurred during sign up. Please try again later.' };
        }
    };

    const verifyUnconfirmedUser = async () => {
        try {
            const response = await fetch(`${apiUrl}/auth/verify-unconfirmed-user`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    email: email,
                    username: username,
                    password: password 
                }),
            });

            const data = await response.json();
            return data; // will return success true or false with message and serverMessage will be set in handleSignUp
        
        } catch (error) {
            console.error('Error during verifying unconfirmed user:', error);
            return { success: false, message: 'An error occurred during verification. Please try again later.' };
        }
    };
    
    useEffect(() => {
        const verifySession = async () => {
            const sessionActive = await checkSession();
            if (sessionActive) {
                navigate('/'); // Redirect to home if session is active
            }
        };
        verifySession();
    }, [navigate]);


    return (
        <div className="wrapper">
            <div className="d-flex justify-content-center" style={{paddingTop: "40px", paddingBottom: "20px", cursor: "pointer"}} onClick={() => navigate('/')}>
                <img src={Logo} alt="Melee Academy Logo" style={{width: "50px", marginRight: "12px"}}/>
                <h2 style={{fontWeight: 600}}>Melee Academy</h2>
            </div>
            {!registerConfirmation ? 
                <Form1 username={username} setUsername={setUsername} email={email} setEmail={setEmail} password={password} setPassword={setPassword} setServerMessage={setServerMessage} setRegisterConfirmation={setRegisterConfirmation} signUp={signUp}/> 
                : <RegistrationConfirmation email={email} signUp={signUp}/>
            }
            {/* Toast Notification */}
            <ToastNotification
                message={serverMessage} 
                setServerMessage={setServerMessage}
            />
        </div>
    )
}

export default Register